export const tryToggleTab = function (event, element) {
    if (!element) return;
    var url = element.href;
    if (!url) return;
    var hash = url.split('#').pop();
    if (!hash) return; 
   
    var $hashlink = $('#myTab a[href="#' + hash + '-tab"]');
    
    if ($hashlink && $hashlink.length) {
        event.preventDefault();
        $hashlink.removeClass('active');
        $hashlink.tab('show');
        
        $(element).closest('div').find('a').removeClass('active');
        $(element).addClass('active');
        
        window.location.href = url;
    }
};